const features = [
  {
    icon: 'ri-file-list-3-line',
    title: '下拉式阅读',
    desc: '全集漫画免费下拉式阅读体验，无需翻页等待。流畅的下滑浏览让你沉浸在漫画世界中，一口气看完一整话。',
  },
  {
    icon: 'ri-timer-line',
    title: '每日同步更新',
    desc: '热门漫画每日追更，第一时间同步最新连载。韩漫日漫国漫更新速度业界领先，追更不等待，精彩不错过。',
  },
  {
    icon: 'ri-global-line',
    title: '韩漫日漫国漫大全',
    desc: '汇聚三大漫画类型精品资源，从热血战斗到甜蜜恋爱，从奇幻穿越到悬疑推理，分类大全满足你的多元口味。',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '漫画排行榜推荐',
    desc: '基于真实阅读数据生成的漫画排行榜，热门推荐帮你快速发现高分好漫画，告别选择困难症。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '桌面端、平板、手机全设备完美适配，无论何时何地，打开浏览器就能免费在线看漫画，即点即看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择YY漫画网
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            五大优势，为你打造极致的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 text-center lg:text-left"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100 flex items-center justify-center mb-4 mx-auto lg:mx-0">
                <span className="w-6 h-6 flex items-center justify-center text-accent-600 text-xl">
                  <i className={f.icon}></i>
                </span>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}